import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { FunctionalLocation } from "@/classes";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";
import FunctionalLocationTree from "@/components/functional-location/tree/FunctionalLocationTree.vue";
import { TreeItem } from "@/components/functional-location/tree/tree";
import { useFilterStore } from "@/store/filter";
import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'functional-location-tree',
  setup(__props) {

const filters = useFilterStore();
filters.initialise("functional-location-tree", [
  {
    label: "No Sup. Func. Loc.",
    value: "no_superior_functional_location",
    type: "boolean",
    default: true,
  },
  {
    label: "Func. Loc. Description",
    value: "functional_location_description",
    type: "string",
  },
]);

const dialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(null);
const tree = ref<InstanceType<typeof FunctionalLocationTree> | null>(null);

const treeItems = ref<TreeItem<FunctionalLocation>[]>([]);

watch(
  () => filters.values,
  async () => {
    const flocs = await FunctionalLocation.getTreeChildren({
      parent_id: null,
      ...filters.values,
    });
    treeItems.value = flocs.map((floc) => {
      return {
        item: floc,
        expanded: false,
        children: null,
      } as TreeItem<FunctionalLocation>;
    });
  },
  { deep: true, immediate: true },
);

const removeItem = (treeItem: TreeItem<FunctionalLocation>) => {
  treeItems.value = treeItems.value.filter(
    (item) => item.item.id !== treeItem.item.id,
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FunctionalLocationTree, {
      ref_key: "tree",
      ref: tree,
      "tree-items": treeItems.value,
      onView: _cache[0] || (_cache[0] = ($event: any) => (dialog.value?.open($event.item.id))),
      onRemove: _cache[1] || (_cache[1] = ($event: any) => (removeItem($event)))
    }, null, 8, ["tree-items"]),
    _createVNode(FunctionalLocationDialog, {
      ref_key: "dialog",
      ref: dialog,
      onChange: _cache[2] || (_cache[2] = ($event: any) => (tree.value?.refresh($event)))
    }, null, 512)
  ]))
}
}

})